import { QueryKeys } from '../../utils/queryKeys';

export const feedbackQuestionsKeys = {
    all: [QueryKeys.GET_FEEDBACK_QUESTIONS_INCLUSIVE_EDUCATION],
    getFeedBackQuestions: () => [...feedbackQuestionsKeys.all],
};